function buildProductOptions1(optionDefinitions, skus, selectedOptions) {
  if (!optionDefinitions?.length) {
    const oneSkuOptions = {};
    for (const element of selectedOptions) {
      oneSkuOptions[element.Key] = [
        {
          Value: element.Value,
          showOption: "valid"
        }
      ];
    }
    return oneSkuOptions;
  }

  // Initialize data structures using Maps for better performance
  const uniqueOptions = new Map();
  const finalOptions = new Map();

  // Initialize options with placeholders
  for (const def of optionDefinitions) {
    uniqueOptions.set(def.Key, new Set());
    finalOptions.set(def.Key, [
      {
        Value: def.PlaceholderText,
        showOption: "default"
      }
    ]);
  }

  // Create a Map for faster SKU option lookups
  const skuOptionsMap = new Map();
  for (const sku of skus) {
    for (const option of sku.OptionValues) {
      if (!skuOptionsMap.has(option.Key)) {
        skuOptionsMap.set(option.Key, new Map());
      }
      if (!skuOptionsMap.get(option.Key).has(option.Value)) {
        skuOptionsMap.get(option.Key).set(option.Value, new Set());
      }
      // Store related options for each key-value pair
      for (const relatedOption of sku.OptionValues) {
        if (relatedOption.Key !== option.Key) {
          skuOptionsMap
            .get(option.Key)
            .get(option.Value)
            .add(`${relatedOption.Key}:${relatedOption.Value}`);
        }
      }
      // Add to unique options if not exists using Value as key to prevent duplicates
      const optionsSet = uniqueOptions.get(option.Key);
      if (optionsSet) {
        optionsSet.add(
          JSON.stringify({
            Value: option.Value,
            SortOrder: option.SortOrder
          })
        );
      }
    }
  }

  // Build final options
  for (const [key, optionsSet] of uniqueOptions) {
    const options = finalOptions.get(key);
    // Convert JSON strings back to objects and ensure uniqueness
    const uniqueOptionsArray = [...optionsSet].map(opt => JSON.parse(opt));
    for (const option of uniqueOptionsArray) {
      options.push({
        Value: option.Value,
        showOption: "valid",
        SortOrder: option.SortOrder
      });
    }
  }

  // Process selected options to mark invalid combinations
  for (const selectedOption of selectedOptions) {
    const validCombos = skuOptionsMap
      .get(selectedOption.Key)
      ?.get(selectedOption.Value);
    if (!validCombos) continue;

    // Create a Set of all possible options for each key
    const allOptionsMap = new Map();
    for (const [key, options] of uniqueOptions) {
      if (key !== selectedOption.Key) {
        allOptionsMap.set(
          key,
          new Set([...options].map(opt => JSON.parse(opt).Value))
        );
      }
    }

    // Remove valid combinations to get invalid ones
    for (const combo of validCombos) {
      const [key, value] = combo.split(":");
      allOptionsMap.get(key)?.delete(value);
    }

    // Mark invalid options
    for (const [key, invalidValues] of allOptionsMap) {
      const options = finalOptions.get(key);
      for (const option of options) {
        if (invalidValues.has(option.Value)) {
          option.showOption = "invalid";
        }
      }
    }
  }

  // Convert Map to object for return
  const result = {};
  for (const [key, value] of finalOptions) {
    result[key] = value;
  }

  return result;
}

function buildCompatibleProductOptions(skus, selectedOptions) {
  // Early return if no data
  if (!skus?.length || !selectedOptions?.length) {
    return {};
  }

  // Create Set of selected keys for faster lookups
  const selectedOptionsMap = new Map(
    selectedOptions.map(opt => [`${opt.Key}-${opt.Value}`, true])
  );

  // Filter skus using Set operations - much faster than array methods
  const compatibleSkus = skus.filter(sku => {
    let matchCount = 0;
    for (const optValue of sku.OptionValues) {
      if (selectedOptionsMap.has(`${optValue.Key}-${optValue.Value}`)) {
        matchCount++;
      }
    }
    return matchCount === selectedOptions.length;
  });

  // Build result object using Map for faster insertions
  const compatibleOptionsMap = new Map();

  // Single pass through compatible skus
  for (const sku of compatibleSkus) {
    for (const optValue of sku.OptionValues) {
      const key = optValue.Key;
      if (!compatibleOptionsMap.has(key)) {
        compatibleOptionsMap.set(key, new Set());
      }
      compatibleOptionsMap.get(key).add(optValue.Value);
    }
  }

  // Convert Map to expected object format
  const result = {};
  for (const [key, valueSet] of compatibleOptionsMap) {
    result[key] = Array.from(valueSet);
  }

  return result;
}

import axios from "axios";

const getMFnotes = (manufacturer, model, productCode) => {
  const url = `/ignitionapi/mountfindertool/GetMFnotes?manufacturer=${manufacturer}&model=${model}&productcode=${productCode}`;
  const config = {
    headers: { Pragma: "no-cache" }
  };

  return axios.get(url, config);
};
export default {
  buildProductOptions1,
  buildCompatibleProductOptions,
  getMFnotes
};
